"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexParent = void 0;
const React = require("react");
function FlexParent({ children, flexDirection, justifyContent, alignItems, margin }) {
    return React.createElement("div", { style: {
            display: 'flex',
            flexDirection: flexDirection,
            justifyContent: justifyContent,
            alignItems: alignItems,
            margin: margin
        } }, children);
}
exports.FlexParent = FlexParent;
